import { contactInfo } from "./index"

export const footer = {
    logo: "https://cdn.shopify.com/s/files/1/0870/4888/0463/files/sleepsoul-blue-logo.svg?v=1724953820",
    logoDefault: false//true default 
}
export const footerType = {
    option : 3 //0 empty => 1 default => 2 fk add style => 3 custom
}

//footer default
export const columnFooter = {
    config: {
        // footer column count setting
        col: '5'
    },
    firstMenu: {
        visible: true,
        title: 'COMPANY',
        items: [
            { label: 'Example', url: '/pages/example' },
            { label: 'Blog', url: '/news' }
        ]
    },
    secondMenu: {
        visible: true,
        title: 'CUSTOMER SERVICE',
        items: [{ html: '<b>Text content specific</b>' },]
    },
    thirdfirstMenu: {
        visible: true,
        title: 'MAIN STORE',
        items: [
            { html: '<b>Units 10 & 11 Beaumond Cross</b>' },
            { html: '<p>Portland Street</p>' },
            { html: '<p>Newark NG24 4XG</p>' },
            { html: '<p>Mon - Sat 9.30am - 5.00pm</p>' },
            { html: '<p>Sun 10.00am - 4.00pm</p>' },
            { html: '<p>Open Bank Holidays</p>' }
        ]
    },
    fourthMenu: {
        visible: true,
        title: 'CLEARANCE STORE',
        items: [
            { html: '<p>Unit 2 Beaumond Cross</p>' },
            { html: '<p>Newark NG24 1XG</p>' },
            { html: '<p class="mb-4">Tues-Sat 10.00am - 4.00pm</p>' },
            { html: '<b>CALL US</b>' },
            { html: '<a href="tel:650474-5424" target="_blank" class="links-footer" title="tel:650474-5424">(650) 474-5424</a>' }
        ]
    },
    fifthMenu: {
        visible: true,
        title: 'STAY CONNECTED',
        newsletter: false,
        socialIcon: {
            visible: true,
            title: 'Check us out online',
            facebook: contactInfo.facebook,
            twitter: contactInfo.twitter,
            instagram: contactInfo.instagram,
            pinterest: contactInfo.pinterest,
            youtube: contactInfo.youtube,
            linkedin: contactInfo.linkedin,
        },
        items: [
            { html: '<b>RetailSystem-</b>' },
            { html: '<p>Company Registration Number</p>' },
            { html: '<p>(650) 474-5424</p>' },
            { html: '<p>Registered Office: 3 Greetwell</p>' },
            { html: '<b>2 Jordan Street,  </b>' },
            { html: '<p>Knott Mill, Manchester,</p>' },
            { html: '<p>M15 4PY.</p>' },
            { html: '<a class="links-footer mt-2" href="mailto:stephen@retailsystem.com">stephen@retailsystem.com</a>' }
        ]
    },
    newsletterInline: false,
    customText: {
        span: "",
        subspan: ""
    }
}

export const paymentIcons = {
    americanExpressPayIcon: true,
    applePayIcon: true,
    dinersClubPayIcon: true,
    discoverPayIcon: true,
    googlePayIcon: true,
    maestroPayIcon: true,
    mastercardPayIcon: true,
    shopPayIcon: true,
    visaPayIcon: true,
    klarnaPayIcon: true
}